import React from 'react'

import SanitizedHtml from '@/components/misc/SanitizedHtml'
import { Badge } from '@/components/ui/badge'
import HtmlContent from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/HtmlContent'
import SectionHeading from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/SectionHeading'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'

const WhereWeCanHelp: React.FC = () => {
  const { situationsWeHelp, clientSegmentsList, aboutUs } =
    useRecommendedPartner()

  const hasClientSegments = clientSegmentsList.length > 0

  return (
    <>
      <section className="flex flex-col gap-12 md:flex-row">
        {(situationsWeHelp || hasClientSegments) && (
          <div className="flex w-full flex-col gap-6 md:w-1/2">
            {situationsWeHelp && (
              <div>
                <SectionHeading>Situations we help</SectionHeading>
                <SanitizedHtml html={situationsWeHelp} />
              </div>
            )}

            {hasClientSegments && (
              <div>
                <SectionHeading>Client segments and profiles</SectionHeading>
                <div className="flex gap-2">
                  {clientSegmentsList.map((segment) => (
                    <Badge key={segment} variant="secondary">
                      {segment}
                    </Badge>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="w-full md:w-1/2">
          <SectionHeading>About us</SectionHeading>
          <HtmlContent html={aboutUs} />
        </div>
      </section>
    </>
  )
}

export default WhereWeCanHelp
